import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export function AddAttributeForm({ onAdd }) {
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    if (name.trim() && await onAdd({ name: name.trim(), description: desc.trim() })) { setName(''); setDesc(''); }
  };
  return (
    <form onSubmit={submit} className="bg-white border border-dashed border-[#CBD5E1] rounded-2xl p-4 flex flex-col md:flex-row gap-3 md:items-center" data-testid="add-attribute-form">
      <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} placeholder="New attribute, e.g. Drive-Thru Experience" className="md:w-72" data-testid="add-attribute-name" />
      <Input value={desc} onChange={(e) => setDesc(e.target.value)} maxLength={300} placeholder="Short description (optional)" className="flex-1" data-testid="add-attribute-description" />
      <Button type="submit" disabled={!name.trim()} className="bg-[#1A3E6F] hover:bg-[#15325A]" data-testid="add-attribute-submit"><Plus className="w-4 h-4 mr-1.5" /> Add attribute</Button>
    </form>
  );
}

export function AddFactorForm({ attributeId, onAdd }) {
  const [name, setName] = useState('');
  const [cls, setCls] = useState('gap');
  const submit = async (e) => {
    e.preventDefault();
    if (name.trim() && await onAdd({ attribute_id: attributeId, name: name.trim(), classification: cls })) setName('');
  };
  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 sm:items-center mt-4 pt-4 border-t border-[#F1F5F9]" data-testid={`add-factor-form-${attributeId}`}>
      <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} placeholder="New factor name" className="h-9 text-sm flex-1" data-testid={`add-factor-name-${attributeId}`} />
      <Select value={cls} onValueChange={setCls}>
        <SelectTrigger className="h-9 sm:w-[160px] text-sm" data-testid={`add-factor-class-${attributeId}`}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="positive_driver">Positive Driver</SelectItem>
          <SelectItem value="gap">Gap</SelectItem>
        </SelectContent>
      </Select>
      <Button type="submit" size="sm" variant="outline" disabled={!name.trim()} className="h-9" data-testid={`add-factor-submit-${attributeId}`}><Plus className="w-3.5 h-3.5 mr-1" /> Add factor</Button>
    </form>
  );
}
